import Endpoints from '@commons/communication/endpoints.js'

export default{
    mixins:[Endpoints],
    data:function () {
        return {
            menus:[]
        };
    },
    computed:{
        webstoreLink:function () {
            return 'http://italshop.borakft.'+(window.testEnv?'myitsolver.com':'hu');
        }
    },
    created:function () {
        var self = this;
        this.connGetMenusTree('MAIN',function (r) {
            self.menus = r.data.list;
            console.log(self.menus);
            // self.$nextTick(function () {
            //     $('.owl-carousel').owlCarousel({
            //         nav:false,
            //         autoWidth:true,
            //         margin:15
            //     })
            // })

        })
    },
}



// WEBPACK FOOTER //
// ./src/app/main/components/bora/BoraHeader.js